(function() {
  vtex.define('shipping/script/module/alphanumponc',[],function() {
    var regex;
    regex = new RegExp(/^[\u00BF-\u1FFF\u2C00-\uD7FF\u3131-\uD79D\wA-Za-zÀ-ž0-9\/\\\-\.\,\s\(\)\'\"\´\`\#ªº°&]*$/);
    return function(val) {
      return regex.test(val);
    };
  });

}).call(this);

